import React from 'react';
import SectionHeader from './section-header.js';
import StructuredData from './structured-data.js';
import '../styles/faq.scss';

// A full-width FAQ section: accordion plus matching FAQPage schema. Native <details> keeps it
// keyboard accessible, working without JS, and leaves every answer in the HTML for search engines.
const FAQ = ({ items, heading = 'FAQs' }) => (
    <section className="ff faq-section">
        <div className="faq">
            <SectionHeader heading={heading} />
            <div className="faq-list">
                {items.map(item => (
                    <details key={item.question} className="faq-item">
                        <summary>
                            <h3 className="faq-question">{item.question}</h3>
                            <span className="faq-icon" aria-hidden="true"></span>
                        </summary>
                        <div className="faq-answer">
                            <p>{item.answer}</p>
                        </div>
                    </details>
                ))}
            </div>
        </div>
        <StructuredData data={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: items.map(item => ({
                "@type": "Question",
                name: item.question,
                acceptedAnswer: { "@type": "Answer", text: item.answer },
            })),
        }} />
    </section>
);

export default FAQ;
